// hooks/useAgingReport.ts

import { useDispatch, useSelector } from "react-redux";

import {
    AppDispatch,
    RootState,
} from "../../../../store/store";

import useLoading
    from "../../../../hooks/useLoading";

import useApiErrorHandler
    from "../../../../hooks/useApiErrorHandler";

import AgingReportService
    from "../services/agingReport.service";

import {
    clearAgingReport,
    setAgingError,
    setAgingLoading,
    setAgingSummary,
    setAgingTable,
} from "../store/agingReport.slice";

import { AgingFilter }
    from "../types/aging.types";

export const useAgingReport = () => {
    const dispatch: AppDispatch = useDispatch();

    const {
        showLoadingIndicator,
        hideLoadingIndicator,
    } = useLoading();

    const { handle } = useApiErrorHandler();

    const {
        summary,
        table,
        paginator,
        page,
        size,
        sort,
        loading,
        error,
    } = useSelector(
        (state: RootState) =>
            state.agingReport
    );

    /**
     * 📊 Obtener resumen superior
     */
    const fetchAgingSummary = async () => {
        try {
            dispatch(
                setAgingLoading(true)
            );

            showLoadingIndicator();

            const data =
                await AgingReportService
                    .getSummary();

            dispatch(
                setAgingSummary(data)
            );

            return data;
        } catch (err: any) {
            dispatch(
                setAgingError(
                    "Error al obtener resumen aging"
                )
            );

            handle(err);

            return null;
        } finally {
            dispatch(
                setAgingLoading(false)
            );

            hideLoadingIndicator();
        }
    };

    /**
     * 📄 Obtener tabla paginada
     */
    const fetchAgingTable = async (
        filters: AgingFilter = {},
        currentPage = 0
    ) => {
        try {
            dispatch(
                setAgingLoading(true)
            );

            showLoadingIndicator();

            const data =
                await AgingReportService
                    .getTable(
                        filters,
                        currentPage,
                        size,
                        sort
                    );

            dispatch(
                setAgingTable(data)
            );

            return data;
        } catch (err: any) {
            dispatch(
                setAgingError(
                    "Error al obtener tabla aging"
                )
            );

            dispatch(
                clearAgingReport()
            );

            handle(err);

            return null;
        } finally {
            dispatch(
                setAgingLoading(false)
            );

            hideLoadingIndicator();
        }
    };

    const clearReport = () => {
        dispatch(
            clearAgingReport()
        );
    };

    return {
        summary,
        table,
        paginator,
        page,
        size,
        sort,
        loading,
        error,

        fetchAgingSummary,
        fetchAgingTable,
        clearReport,
    };
};